import { Select } from "antd";
import { getTradersByTradingCompanyId } from "api/teamRunApi";
import {
  API_KEYS,
  BACKEND_KEYS_NAME,
} from "constants/editTradeDetails";
import { GlobalContext } from "contexts/GlobalContext";
import { getDataFromLocalStorage } from "helpers/generalHelper";
import { useContext, useEffect, useState } from "react";

function TraderDropdown({
  item,
  onChange,
  tradingCompanyId,
  apiData,
  setTraderId,
  minWidth,
  id,
  isDisabled,
  isAllowClear = true,
  productId,
}) {
  
  const [isLoading, setIsLoading] = useState(false);
  const [traders, setTraders] = useState([]);
  const {
    globalState: { dark_Theme },
  } = useContext(GlobalContext);
  const initialTrade = getDataFromLocalStorage("initialTrade");
  
  useEffect(() => {
    fetchTraders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tradingCompanyId]);

  const fetchTraders = async () => {
    if (!tradingCompanyId) return;
    setIsLoading(true);
    try {
      const response = await getTradersByTradingCompanyId(tradingCompanyId,productId);
      setTraders(response.data.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    onChange(id, initialTrade?.trader, initialTrade?.trader_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tradingCompanyId]);

  return (
    <Select
      placeholder={
        apiData?.[API_KEYS.TRADE_PLACEHOLDER] || "Search Trading Companies"
      }
      value={item[BACKEND_KEYS_NAME.TRADER]??initialTrade?.trader_id}
      onChange={(value) => {
        const label = traders?.find((item) => item?.trader_id === value)?.label;
        onChange(id, label??initialTrade?.trader, value??initialTrade?.trader_id);
        setTraderId(value);
      }}
      allowClear={isAllowClear}
      showSearch
      filterOption={(input, option) => {
        const inputSmallLetter = input.toLowerCase();
        const label = option.children.toLowerCase();
        return label.includes(inputSmallLetter);
      }}
      disabled={isDisabled || isLoading}
      defaultValue={apiData?.trader??initialTrade?.trader_id}
      loading={isLoading}
      style={{ width: 180, minWidth: minWidth }}
      notFoundContent={
        <p
          style={{ color: dark_Theme ? "gray" : "black", textAlign: "center" }}
        >
          Please select trading company first
        </p>
      }
      className={
        dark_Theme
          ? "select-dark edit-company-trader-input"
          : "edit-company-trader-input"
      }
      popupClassName={dark_Theme ? "dropdown-dark" : ""}
    >
      {tradingCompanyId &&
        traders.map((item) => (
          <Select.Option key={item.trader_id} value={item.trader_id}>
            {item.label}
          </Select.Option>
        ))}
    </Select>
  );
}

export default TraderDropdown;
